import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';

function Header() {
  return (
    <header className="app-header">
      <div className="logo-container"></div>
      <nav className="header-nav">
        <Link to="/" className="nav-button">Calendrier</Link>
        <Link to={`/daily/${new Date().toISOString().split('T')[0]}`} className="nav-button">Aujourd'hui</Link>
      </nav>
    </header>
  );
}

export default Header;

